import PropTypes from 'prop-types';

import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from 'utils/history';

const propTypes = {
  data: PropTypes.any,
}

function UserHeading({ data, active, onChangeActive }) {
  return <>
    <HeaderContainerForm
      title='Users'
      data={{ ...data, name: `${data?.first_name} ${data?.last_name}`, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
      onCancel={() => history.goBack()}
    >
      <ActiveForm active={active} onChangeActive={onChangeActive} />
    </HeaderContainerForm>
  </>
}
export default UserHeading

UserHeading.propTypes = propTypes
UserHeading.defaultProps = {}
